import { useFormContext } from "react-hook-form";

import Input from "Components/Global/Form/Input";

import * as S from "./styles";

const DateInput = ({
  label,
  start_name,
  finish_name,
  start_label,
  finish_label,
  gridArea,
  disabled,
}) => {
  const { register } = useFormContext();

  return (
    <S.Wrapper gridArea={gridArea}>
      <label>{label}</label>
      <S.Row>
        <Input
          {...register(start_name)}
          placeholder="Digite aqui"
          label={start_label}
          type="date"
          width="100%"
          disabled={disabled}
        />
        <S.To hasLabel={start_label || finish_label}>até</S.To>
        <Input
          {...register(finish_name)}
          placeholder="Digite aqui"
          label={finish_label}
          type="date"
          width="100%"
          disabled={disabled}
        />
      </S.Row>
    </S.Wrapper>
  );
};

export default DateInput;
